class SidebarMenuController {

    constructor($scope, $routeParams, CONTENT_TYPE) {

        this.$scope = $scope;
        this.CONTENT_TYPE = CONTENT_TYPE;

        if($routeParams.hasOwnProperty('clientId')) {
            this.clientId = $routeParams.clientId;
        }

        if($routeParams.hasOwnProperty('accountId')) {
            this.accountId = $routeParams.accountId;
        }

        if($routeParams.hasOwnProperty('advertiserId')) {
            this.advertiserId = $routeParams.advertiserId;
        }

        if($routeParams.hasOwnProperty('campaignId')) {
            this.campaignId = $routeParams.campaignId;
        }

        if($routeParams.hasOwnProperty('feedId')) {
            this.feedId = $routeParams.feedId;
        }


    }

    urlForBranch() {

        var url = "";

        try {
            switch(this.entityType) {

            case this.CONTENT_TYPE.FEED:
                url =  "/account/" + this.accountId + "/" + this.advertiserId + "/feed/" + this.feedId ;
                break;

            case this.CONTENT_TYPE.CAMPAIGN:
                url =  "/account/" + this.accountId + "/" + this.advertiserId + "/campaign/" + this.campaignId ;
                break;

            case this.CONTENT_TYPE.ADVERTISER:
                url = "/account/" + this.accountId + "/" + this.advertiserId;
                break;

            case this.CONTENT_TYPE.ACCOUNT:
                url = "/account/" + this.accountId;
                break;

            case this.CONTENT_TYPE.CLIENT:
                url = "/accounts";
                break;
            }
        }
        catch(e) {
            // NOOP
        }

        return url;
    }

    urlForLeaf(leaf) {
        return this.urlForBranch() + leaf;
    }

    entityId() {

        var id = "";

        try {
            switch(this.entityType) {
            case this.CONTENT_TYPE.FEED:
                id = this.feedId ;
                break;

            case this.CONTENT_TYPE.CAMPAIGN:
                id = this.campaignId ;
                break;

            case this.CONTENT_TYPE.ADVERTISER:
                id = this.advertiserId;
                break;

            case this.CONTENT_TYPE.ACCOUNT:
                id = this.accountId;
                break;

            }
        }
        catch(e) {
            // NOOP
        }

        return id;

    }
}

class SidebarMenu {

    constructor($rootScope, $routeParams, ApiService, CONTENT_TYPE) {
        
        this.$rootScope = $rootScope;
        this.$routeParams = $routeParams;
        this.ApiService = ApiService;
        this.CONTENT_TYPE = CONTENT_TYPE;

        this.entities = {};
        this.clientId = "";
        this.accountId = "";
        this.advertiserId = "";                
        this.campaignId = "";

        let _self = this;        

        return {
            restrict: 'E',
            transclude: true,
            templateUrl: "components/sidebar-menu-directive.html",
            scope: {
                entityType: "@"
            },
            compile: ($el, $attr) => {
                return {
                    pre: ($scope, $el, $attr) => {
                        $scope.sidebarMenuCrtl.entityType = $scope.entityType;
                    },
                    post: angular.noop
                }
			},
            controllerAs: "sidebarMenuCrtl",
            controller: ['$scope', '$routeParams', 'CONTENT_TYPE', SidebarMenuController]
		};

	}

    getEntity($scope, contentType, entityId) {

        if(!entityId) {
            this.entities[contentType] = null;
        }
        else {
            this.ApiService.get(contentType, entityId)
                .then(resp => {
                    this.entities[contentType] = { id: resp.data.id, name: resp.data.name };
                    this.startCalculateBreadcrumbs($scope);
                },
                () => {
                    this.entities[contentType] = { id: 0, name: "Not found" };
                });
        }

    }

    updateEntityIds($scope) {

        if(this.$routeParams.hasOwnProperty('clientId')) {
            $scope.clientId = this.$routeParams.clientId;
        }

        if(this.$routeParams.hasOwnProperty('accountId')) {
            $scope.accountId = this.$routeParams.accountId;
        }

        if(this.$routeParams.hasOwnProperty('advertiserId')) {
            $scope.advertiserId =this.$routeParams.advertiserId;
        }

        if(this.$routeParams.hasOwnProperty('campaignId')) {
            $scope.campaignId = this.$routeParams.campaignId;
        }

        if(this.$routeParams.hasOwnProperty('feedId')) {
            $scope.feedId = this.$routeParams.feedId;
        }

    }

    startCalculateBreadcrumbs($scope) {
        

        $scope.breadcrumbs = [];
        if($scope.isLeaf) {
            $scope.breadcrumbs.push({ url: "", name: $scope.prefix });
        }

        this.calculateBreadcrumbs($scope, $scope.entityType);

        try {
            switch($scope.entityType) {

            case this.CONTENT_TYPE.FEED:
                $scope.title = this.entities[this.CONTENT_TYPE.ADVERTISER].name + " - " + this.entities[this.CONTENT_TYPE.FEED].name;
                break;

            case this.CONTENT_TYPE.CAMPAIGN:
                $scope.title = this.entities[this.CONTENT_TYPE.ADVERTISER].name + " - " + this.entities[this.CONTENT_TYPE.CAMPAIGN].name;
                break;

            case this.CONTENT_TYPE.ADVERTISER:
                $scope.title = this.entities[this.CONTENT_TYPE.ACCOUNT].name + " - " + this.entities[this.CONTENT_TYPE.ADVERTISER].name;
                break;

            case this.CONTENT_TYPE.ACCOUNT:
                $scope.title = this.entities[this.CONTENT_TYPE.ACCOUNT].name;
                break;

            case this.CONTENT_TYPE.CLIENT:
                $scope.title = "Accounts";
                break;
            }
        }
        catch(e) {
            // NOOP
        }
    }

    calculateBreadcrumbs($scope, entityType) {

        try {
            switch(entityType) {
            case this.CONTENT_TYPE.FEED:

                $scope.breadcrumbs.unshift( { 
                    url: "/account/" + this.accountId + "/" + this.advertiserId + "/feed/" + this.feedId, 
                    name: this.entities[this.CONTENT_TYPE.FEED].name
                });

                this.calculateBreadcrumbs($scope, this.CONTENT_TYPE.ADVERTISER);
                break;

            case this.CONTENT_TYPE.CAMPAIGN:

                $scope.breadcrumbs.unshift( { 
                    url: "/account/" + this.accountId + "/" + this.advertiserId + "/campaign/" + this.campaignId, 
                    name: this.entities[this.CONTENT_TYPE.CAMPAIGN].name
                });

                this.calculateBreadcrumbs($scope, this.CONTENT_TYPE.ADVERTISER);
                break;

            case this.CONTENT_TYPE.ADVERTISER:

                $scope.breadcrumbs.unshift( { 
                    url: "/account/" + this.accountId + "/" + this.advertiserId, 
                    name: this.entities[this.CONTENT_TYPE.ADVERTISER].name
                });

                this.calculateBreadcrumbs($scope, this.CONTENT_TYPE.ACCOUNT);
                break;

            case this.CONTENT_TYPE.ACCOUNT:

                $scope.breadcrumbs.unshift( { 
                    url: "/account/" + this.accountId,
                    name: this.entities[this.CONTENT_TYPE.ACCOUNT].name
                });

                this.calculateBreadcrumbs($scope, this.CONTENT_TYPE.CLIENT);
                break;

            case this.CONTENT_TYPE.CLIENT:
                $scope.breadcrumbs.unshift( { url: "/accounts", name: "Accounts" } );
                break;
            }
        }
        catch(e) {
            // NOOP
        }
    }


}

class SidebarMenuLeaf {
    constructor($rootScope, $routeParams, $location, ApiService, CONTENT_TYPE) {


        return {
            restrict: 'E',
            require: "^^sidebarMenu",
            transclude: true,
            template: "<a ng-href='{{url}}'><i class='fa {{icon}}'> </i> <ng-transclude></ng-transclude></a>",
            scope: {
                icon: "@",
                tail: "@"
            },
            link: ($scope, $el, $attr, sidebarMenuCrtl) => {
                
                $scope.url = sidebarMenuCrtl.urlForLeaf($scope.tail);
                if($scope.url === $location.path()) {
                    $el.addClass("active");
                }
            }
        };
    }
}

class SidebarMenuBranch {
    constructor($rootScope, $routeParams, $location, ApiService, CONTENT_TYPE) {


        return {
            restrict: 'E',
            require: "^^sidebarMenu",
            transclude: true,
            template: "<a ng-href='{{url}}'><i class='fa {{icon}}'> </i> <ng-transclude></ng-transclude></a>",
            scope: {
                icon: "@",
                root: "@"
            },
            link: ($scope, $el, $attr, sidebarMenuCrtl) => {
                
                if(!!$scope.root) {
                    $scope.url = $scope.root + sidebarMenuCrtl.entityId();
                }
                else {
                    $scope.url = sidebarMenuCrtl.urlForBranch();
                }

                if($scope.url === $location.path()) {
                    $el.addClass("active");
                }

            }
        };
    }
}

angular.module('cpm')
    .directive('sidebarMenu', ['$rootScope', "$routeParams", "ApiService", "CONTENT_TYPE", ($rootScope, $routeParams, ApiService, CONTENT_TYPE) => {
        'use strict';
        return new SidebarMenu($rootScope, $routeParams, ApiService, CONTENT_TYPE);
    }])
    .directive('leaf', ['$rootScope', "$routeParams", "$location", "ApiService", "CONTENT_TYPE", ($rootScope, $routeParams, $location, ApiService, CONTENT_TYPE) => {
        'use strict';
        return new SidebarMenuLeaf($rootScope, $routeParams, $location, ApiService, CONTENT_TYPE);
    }]).directive('branch', ['$rootScope', "$routeParams", "$location", "ApiService", "CONTENT_TYPE", ($rootScope, $routeParams, $location, ApiService, CONTENT_TYPE) => {
        'use strict';
        return new SidebarMenuBranch($rootScope, $routeParams, $location, ApiService, CONTENT_TYPE);
    }]);
